module.exports = __webpack_public_path__ + "img/spc-navbar-tablet.455c12d.png";